export default __webpack_public_path__ + "static/media/down-arrow.c98d6ce0.svg";